import styled from 'styled-components'
import { ImageAsset } from '@/components/common'
import { ImageAssetNameType } from '@/components/common/assets/ImageAssetBase'
import { NewCol } from '@/components/common/layouts/NewCol'
import { NewRow } from '@/components/common/layouts/NewRow'
import { GlobalColorEnum } from '@/constants/global-color.enum'
import { PaymentMethodTypeKorean } from '@/constants/legacy/constData'
import { SCREEN_MEDIA_QUERY } from '@/constants/legacy/constLayout'
import { PaymentMethodTypeEnum } from '@/constants/payment-method-type.enum'
import { PaymentMethodsWithBenefit } from '@/types/payment-method-benefit.type'

type PayMethodButtonsProps = {
  paymentMethodsWithBenefit: PaymentMethodsWithBenefit[]
  selectedMethod: PaymentMethodTypeEnum
  onSelect: (method: PaymentMethodTypeEnum) => void
}

export const PayMethodButtons = ({ paymentMethodsWithBenefit, selectedMethod, onSelect }: PayMethodButtonsProps) => {
  const handleClick = (paymentMethod: PaymentMethodTypeEnum) => {
    onSelect(paymentMethod)
  }

  return (
    <NewRow wrap={true} justify="space-between">
      {paymentMethodsWithBenefit.map((item) => {
        const selected = item.method === selectedMethod
        return (
          <NewCol
            key={item.method}
            style={{
              width: item.method === PaymentMethodTypeEnum.TossPay ? '100%' : `calc(50% - 0.4rem)`,
            }}
            onClick={() => handleClick(item.method)}
            data-cy={item.method}
          >
            <StyledButton className="button" selected={selected ? 1 : 0}>
              {/* 혜택 뱃지 */}
              {!!item.benefit?.contents && <StyledBenefitBox>혜택</StyledBenefitBox>}
              {/* 텍스트버튼, 이미지 버튼 구분 */}
              {!item.icon ? (
                <StyledText selected={selected}>{PaymentMethodTypeKorean[item.method]}</StyledText>
              ) : (
                <ImageAsset name={`logo_${item.icon.name}` as ImageAssetNameType} size={item.icon.size} />
              )}
            </StyledButton>
          </NewCol>
        )
      })}
    </NewRow>
  )
}

const StyledButton = styled.div<{ selected: number }>`
  position: relative;
  border: ${({ selected }) =>
    selected ? `1px solid ${GlobalColorEnum.Blue500}` : `1px solid ${GlobalColorEnum.Gray200}`};
  box-sizing: border-box !important;
  border-radius: 8px;
  background-color: ${(props) => props.theme.color.grayWhite};
  justify-content: center;
  align-items: center;
  display: flex;
  height: 48px;
  margin-bottom: 8px;
  background-color: ${({ selected }) => (selected ? GlobalColorEnum.Blue30 : GlobalColorEnum.GrayWhite)};
`

const StyledText = styled.span<{ selected: boolean }>`
  font-size: 16px;
  font-weight: ${({ selected }) => {
    if (selected) return 600
    return 500
  }};

  color: ${({ selected }) => {
    if (selected) return GlobalColorEnum.Blue500
    return GlobalColorEnum.Gray900
  }};

  @media ${SCREEN_MEDIA_QUERY.xs} {
    font-size: 15px;
  }
`

const StyledBenefitBox = styled.div`
  width: 31px;
  height: 20px;
  position: absolute;
  left: 0;
  top: -0.6rem;
  background-color: ${(props) => props.theme.color.red500};
  text-align: center;
  border-radius: 10px 10px 0 10px;
  font-size: 11px;
  font-weight: 700;
  color: ${(props) => props.theme.color.grayWhite};
  display: flex;
  align-items: center;
  justify-content: center;
`
